<template lang="pug">
.container.solicitarPermuta
  .card
    cadastro-sicarf(titleCadastro="Solicitar permuta", routeName="permuta", :cadastroEmpty="empty", :tabs="tabs")
</template>

<script>
import CadastroSicarf from '@/screens/central/components/CadastroSicarf'
import empty from '../empty/emptyPermuta'

export default {

  components: {
    CadastroSicarf
  },

  data () {
    return {
      // O atributo @name deve ser o mesmo da rota definida no router
      tabs: [
        {
          label: 'Cadastrante',
          name: 'permuta/cadastrante',
          codigo: 'CADASTRANTE'
        },
        {
          label: 'Interessado',
          name: 'permuta/interessado',
          codigo: 'INTERESSADO'
        },
        {
          label: 'Imóvel',
          name: 'permuta/imovel',
          codigo: 'IMOVEL'
        },
        {
          label: 'Georreferenciamento',
          name: 'permuta/georreferenciamento'
        },
        {
          label: 'Resumo',
          name: 'permuta/resumo',
          isResumo: true
        }
      ],
      empty: empty
    }
  }

}
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  .card {
    width: 100%;
  }
}

@media (max-width: 780px) {
  .solicitarPermuta {
    position: relative;
    top: 60px;
    right: 60%;
    width: 360px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/permuta/Cadastro.vue